const EpochTypes = {
    30: '_30S',
    60: '_60S',
    120: '_120S',
}

export default EpochTypes;